<script setup lang="ts">
import type { IPropSizes } from './styles';

interface Props extends IPropSizes {
  showDefaultClose?: boolean | undefined;
  bgClickClose?: boolean | undefined;
  value?: boolean | null | undefined;
  rounded?: boolean | undefined;
  className?: String | string | undefined;
  [x: string]: any;
};

const props = withDefaults(defineProps<Props>(), {
  showDefaultClose: false,
  bgClickClose: false,
  rounded: true,
});

const slots = useSlots();

const emit = defineEmits(['click', 'change']);
const model = defineModel<boolean>({ required: false, default: false });

const init = (): void => {
  if (props.value !== undefined)
    model.value = props.value;
};
init();

// Expose usefull functions
defineExpose({ init });
</script>

<!-- Use preprocessors via the lang attribute! e.g. <template lang="pug"> -->
<template>
  <transition name="fade">
    <div
      v-if="model"
      class="fixed inset-0 z-50 grid justify-center items-center w-full h-full overflow-auto"
      @click="(e: Event) => emit('click', e)">
      <slot name="background">
        <span
          :class="[
            'fixed inset-0 bg-slate-600 transition-opacity opacity-75',
            (((isSlotEmpty(slots?.default) && (! slots.box)) || bgClickClose) && 'cursor-pointer')
          ]"
          @click="(e: Event) => (((isSlotEmpty(slots?.default) && (! slots.box)) || bgClickClose) ? (model = false, emit('change', e)) : null)" />
      </slot>
      <slot name="box">
        <BaseBox
          :size="size"
          :rounded="rounded"
          :class="[
            'relative transform transition-all',
            className
          ]">
          <slot>
            <h3 class="bg-white rounded-lg shadow-xl p-6 text-center text-lg font-bold text-red-500">
              ! NO CONTENT !
            </h3>
          </slot>
          <slot name="close">
            <button
              v-if="((isSlotEmpty(slots?.default) && (! slots.box)) || showDefaultClose)"
              type="button"
              class="absolute top-0 right-0 m-2 sm:m-3 md:m-4 lg:m-5 xl:m-6"
              @click="(e: Event) => (model = false, emit('change', e))">
              <Icon
                class="text-black text-center align-middle w-8 h-8 scale-[1.0] sm:scale-[1.25] lg:scale-[1.5] xl:scale-[1.75] hover:scale-[1.25] sm:hover:scale-[1.5] md:hover:scale-[1.75] lg:hover:scale-[2.0] xl:hover:scale-[2.0] ease-in duration-200"
                name="bx:x"
                size="48" />
            </button>
          </slot>
        </BaseBox>
      </slot>
    </div>
  </transition>
</template>


<style lang="scss" scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transition: ease 0.2s;
}

.fade-leave-from,
.fade-enter-to {
  opacity: 1;
  transition: ease 0.2s;
}
</style>
